import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
const ProfileDetails = lazy(() => import("./pages/auth/profile-details"));
import { ProfileForm } from "./components/profile-components/profile-form";
import SignupPage from "./pages/auth/signup.jsx";
const AreaInvest = lazy(() => import("./pages/investment-map/AreaInvest"));
import VeriffStatus from "./pages/auth/kyc-verification/verification-status";
import InvestMarket from "./pages/investment/invest-market";
import TwoFactorVerification from "./pages/auth/login/2fa-verification";
import BlogDetails from "./pages/blogs/details";
import { OnlyLoggedIn, OnlyLoggedOut } from "./common/private-route/wrappers";
import FeaturesTab from "./pages/move-to-app/features";
import AppLayout from "./common/private-route/MobileWrapper";


const RLCN =lazy(() => import("./pages/rlcn"));
const Blogs = lazy(() => import("./pages/blogs"));
const PaymentSuccess = lazy(() => import("./pages/payments/success"));
const PaymentCancel = lazy(() => import("./pages/payments/cancel"));
const Fulfillment = lazy(() => import("./pages/fullfilment"));
const PrivacyPolicy = lazy(() => import("./pages/privacy-policy"));
const AboutUs = lazy(() => import("./pages/about-us"));
const HowItWorksPage = lazy(() => import("./pages/how-it-works"));
const ForgotPassword = lazy(() => import("./pages/auth/forgot-password"));
const PhoneDetailSteps = lazy(() => import("./pages/auth/phone-details"));
const KycVerification = lazy(() => import("./pages/auth/kyc-verification"));
const MissingSteps = lazy(() => import("./pages/missing-steps"));
const RecentTransactions = lazy(
  () => import("./pages/account-page/RecentTransactions"),
);
const AuthLayout = lazy(() => import("@/layout/auth-layout"));
const Home = lazy(() => import("@/pages/home"));
const DefaultLayout = lazy(() => import("@/layout"));
const NotFound = lazy(() => import("./pages/error-pages/404"));
const ErrorPage = lazy(() => import("./pages/error-pages/500"));
const AccountPage = lazy(() => import("./pages/account-page"));
const LoginPage = lazy(() => import("./pages/auth/login/login"));
const ContactUs = lazy(() => import("./pages/contact-us"));
const MyProperty = lazy(() => import("./pages/my-property"));
const Investment = lazy(() => import("./pages/investment"));
const InvestmetMap = lazy(() => import("./pages/investment-map"));
const ComingSoon = lazy(() => import("./pages/coming-soon"));
const Portfolio = lazy(() => import("./pages/portfolio"));
const NotificationSettings = lazy(
  () => import("./components/profile-components/notification"),
);
const Subscription = lazy(
  () => import("./components/profile-components/subscription"),
);
const AccountSettings = lazy(
  () => import("./components/profile-components/settings"),
);
const PasswordChangeForm = lazy(
  () => import("./components/profile-components/change-password"),
);
const PendingTransactions = lazy(
  () => import("./components/profile-components/pending-queued-tx"),
);
const ComingSoonWrapper = lazy(() => import("./common/private-route/ComingSoonWrapper"));
const PrivateRoute = lazy(() => import("./common/private-route"));
const ProfileLayout = lazy(() => import("./layout/profile-layout"));
const RedirectedRoute = lazy(
  () => import("./common/private-route/redirected-route"),
);

const router = createBrowserRouter([
  // {
  //   path: "/auth",
  //   element: <ComingSoonWrapper><AuthLayout /></ComingSoonWrapper>,
  //   errorElement: <ErrorPage />,
  //   children: [
  //     {
  //       path: "login",
  //       element: <OnlyLoggedOut><LoginPage /></OnlyLoggedOut>,
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "two-factor-verify",
  //       element: <TwoFactorVerification />,
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "signup",
  //       element: <OnlyLoggedOut><SignupPage /></OnlyLoggedOut>,
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "forgot-password",
  //       element: <ForgotPassword />,
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "phone-details",
  //       element: 
  //         <PhoneDetailSteps />,
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "profile-details",
  //       element: <ProfileDetails />,
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "kyc-verification",
  //       element: <KycVerification />,
  //       errorElement: <ErrorPage />,
  //     },
  //   ],
  // },
  {
    path: "/",
    element:<DefaultLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          // <RedirectedRoute>
            <Home />
          // </RedirectedRoute>
        ),
        errorElement: <ErrorPage />,
      },
      // {
      //   path: "/portfolio/details/:id",
      //   element: (
      //     <PrivateRoute>
      //       <MyProperty />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      {
        path: "/rlcn",
        element: (
            <RLCN/>
        ),
        errorElement: <ErrorPage />,
      },
      // {
      //   path: "/account",
      //   element: (
      //     <PrivateRoute>
      //       <AccountPage/>
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      {
        path: "/blogs",
        element: <Blogs />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/blogs/:id",
        element: <BlogDetails />,
        errorElement: <ErrorPage />,
      },
      // {
      //   path: "/account/recent-transactions",
      //   element: (
      //     <PrivateRoute>
      //       <RecentTransactions />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      {
        path: "/contact-us",
        element: <ContactUs />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/features",
        element: <FeaturesTab />,
        errorElement: <ErrorPage />,
      },
      // {
      //   path: "/investment",
      //   element: (
      //     <PrivateRoute>
      //       <Investment />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/investment/details/:id",
      //   element: (
      //     <PrivateRoute>
      //       <InvestmetMap />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/investment/market/:id",
      //   element: (
      //     <PrivateRoute>
      //       <InvestMarket />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/investment/details/static",
      //   element: (
      //     <PrivateRoute>
      //       <AreaInvest />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/portfolio",
      //   element: (
      //     <PrivateRoute>
      //       <Portfolio />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/profile",
      //   element: (
      //     <PrivateRoute>
      //       <ProfileLayout />
      //     </PrivateRoute>
      //   ),
      //   errorElement: <ErrorPage />,
      //   children: [
      //     { path: "me", element: <ProfileForm />, errorElement: <ErrorPage /> },
      //     { path: "settings", element: <AccountSettings />, errorElement: <ErrorPage /> },
      //     { path: "subscription", element: <Subscription />, errorElement: <ErrorPage /> },
      //     { path: "notification", element: <NotificationSettings />, errorElement: <ErrorPage /> },
      //     { path: "pending-transactions", element: <PendingTransactions />, errorElement: <ErrorPage /> },
      //     { path: "change-password", element: <PasswordChangeForm />, errorElement: <ErrorPage /> },
      //   ],
      // },
      {
        path: "/payment/success",
        element: <PaymentSuccess />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/payment/cancel",
        element: <PaymentCancel />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/fulfillment-policy",
        element: <Fulfillment />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
        errorElement: <ErrorPage />,
      },
      // {
      //   path: "/about-us",
      //   element: <AboutUs />,
      //   errorElement: <ErrorPage />,
      // },

      // {
      //   path: "/how-it-works",
      //   element: <HowItWorksPage />,
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/missing-steps",
      //   element: <MissingSteps />,
      //   errorElement: <ErrorPage />,
      // },
      // {
      //   path: "/veriff-status",
      //   element: <VeriffStatus />,
      //   errorElement: <ErrorPage />,
      // },
      { path: "*", element: <NotFound />, errorElement: <ErrorPage /> },
    ],
  },
]);

export default router;